import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Card, Text } from 'react-native-paper';
import { useThemeSettings } from '../../../ThemeProvider';
import { IScenario } from '../types';
import { useTranslation } from 'react-i18next';
import { useActiveArticleStore } from '../../../store/activeArticleStore';

interface ScenarioContentProps {
  content: IScenario[];
  style?: object;
}

const colorMapping: any = {
  "Negative": "#E81212",
  "Positive": "#09671D",
  "Neutral": "#7E7762",
}

const formatScenarioTitle = (scenario: string) => {
  return scenario
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join('-');
};
export const ScenarioContent: React.FC<ScenarioContentProps> = ({ content, style = {} }) => {
  const { theme } = useThemeSettings();
  const { t } = useTranslation();

  const { activeView} = useActiveArticleStore();
  const getScenarioText = (scenarioPoint: any) => <Text
    style={{ color: theme?.colors?.onSurface }}
    variant="bodyMedium"
  >
    {scenarioPoint}
  </Text>
  const getScenarioCard = (scenarios: IScenario[], type: string) => {
    const typeKey = type.replace(' ', '_');
    return <Card
      key={typeKey}
      style={[styles.scenarioCard, 
        {elevation: activeView.startsWith('NEXT_DROP') ? 2 : 0},
        { backgroundColor: theme?.colors?.btnBgFill }]}
    >
      <View style={{ gap: 8 }}>
        <Text style={[{ color: theme?.colors?.secondary, fontSize: 18 }]}>{t(`screens.article.${typeKey.toLowerCase()}`)}</Text>
        {scenarios.map((scenario: IScenario, index: number) => {
          return <View key={`type${index}`}>
            {Array.isArray(scenario.scenario) ? (
              scenario.scenario.map((item, index) => (
                <View key={`${type}-bullet-${index}`} style={{ flexDirection: "row" }}>
                  <Text style={{ marginRight: 8 }}>•</Text>
                  <Text style={{ display: 'flex' }}>
                    {getScenarioText(item)}</Text>
                </View>
              )))
              : getScenarioText(scenario.scenario)
            }
            <View style={styles.sentimentRow}>
               <Text style={[styles.probability, { color: colorMapping[scenario.sentiment] }]} variant="bodySmall" >
              {t(`screens.article.sentiment.${scenario.sentiment.toLowerCase()}`)}
              </Text> 
               {/* <Text style={[styles.probability, { color: colorMapping[scenario.sentiment] }]} variant="bodySmall" >
                {t('screens.article.probability')}: {(scenario.probability).toFixed(0)}%
              </Text>  */}
            </View>
          </View>
        })}
      </View>
    </Card>
  }
  return (
    <View style={{gap:16}}>
      {getScenarioCard(content.filter((c) => c.timeframe === "Short Term"), 'Short Term')}
      {getScenarioCard(content.filter((c) => c.timeframe === "Long Term"), 'Long Term')}
    </View>
  );
};

const styles = StyleSheet.create({
  
  scenarioCard: {
    padding: 16,
  },
  probability: {
    fontStyle: 'italic',
    flex : 1,
  },
  sentimentRow: {
    display: 'flex',
    flexDirection: 'row',
    paddingTop: 12,
    justifyContent: 'space-between'
  }
});

export default ScenarioContent;
